(function () {
  'use strict';
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  function bound(state, width, height) {
    state.scale = clamp(state.scale, 1, 3);
    state.x = clamp(state.x, -width * (state.scale - 1) / 2, width * (state.scale - 1) / 2);
    state.y = clamp(state.y, -height * (state.scale - 1) / 2, height * (state.scale - 1) / 2);
    return state;
  }
  function swipe(dx, dy) { return Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5 ? (dx < 0 ? 1 : -1) : 0; }
  if (typeof module !== 'undefined' && module.exports) module.exports = { bound, swipe };
  if (typeof document === 'undefined') return;

  function mount(root) {
    if (root.dataset.rideInteractions) return;
    const viewport = root.querySelector('[data-ride-viewport]');
    const stage = root.querySelector('[data-ride-stage]');
    const slides = [...root.querySelectorAll('[data-ride-slide]')];
    if (!viewport || !stage || !slides.length) return;
    root.dataset.rideInteractions = 'true';
    const details = [...root.querySelectorAll('[data-ride-detail]')];
    const zoomIn = root.querySelector('[data-ride-zoom-in]');
    const zoomOut = root.querySelector('[data-ride-zoom-out]');
    const previous = root.querySelector('[data-ride-previous]');
    const next = root.querySelector('[data-ride-next]');
    let state = { scale: 1, x: 0, y: 0 }, index = 0, gesture = null, suppressUntil = 0;
    function render() {
      bound(state, viewport.clientWidth, viewport.clientHeight);
      stage.style.transform = `translate(${state.x}px, ${state.y}px) scale(${state.scale})`;
      viewport.dataset.zoomed = String(state.scale > 1);
      zoomOut.disabled = state.scale <= 1;
      zoomIn.disabled = state.scale >= 3;
      root.querySelector('[data-ride-zoom-label]').textContent = `${Math.round(state.scale * 100)}%`;
    }
    function reset() { state = { scale: 1, x: 0, y: 0 }; render(); }
    function change(delta) {
      index = (index + delta + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      details.forEach((detail, i) => { detail.hidden = i !== index || i === 0; });
      root.querySelector('[data-ride-count]').textContent = `${index + 1} / ${slides.length}`;
      reset();
    }
    function zoom(delta) { state.scale += delta; render(); }
    zoomIn.addEventListener('click', () => zoom(.5));
    zoomOut.addEventListener('click', () => zoom(-.5));
    root.querySelector('[data-ride-reset]').addEventListener('click', reset);
    previous.addEventListener('click', () => change(-1));
    next.addEventListener('click', () => change(1));
    root.addEventListener('rbnl:show-main-scene', () => change(-index));
    previous.hidden = next.hidden = slides.length < 2;
    root.querySelector('[data-ride-controls]').hidden = false;
    const hint = root.querySelector('[data-ride-gesture-hint]');
    hint.hidden = false;
    hint.textContent = slides.length > 1 ? 'Veeg om te wisselen. Zoom in en sleep voor details.' : 'Zoom in en sleep om details te bekijken.';
    root.addEventListener('click', event => {
      if (Date.now() < suppressUntil && event.target.closest('[data-ride-viewport]')) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    }, true);
    viewport.addEventListener('dragstart', event => event.preventDefault());
    function start(points) {
      gesture = { startX: points[0].clientX, startY: points[0].clientY, x: state.x, y: state.y,
        scale: state.scale, moved: false, pinch: points.length > 1, dx: 0, dy: 0 };
      if (gesture.pinch) {
        gesture.distance = Math.hypot(points[0].clientX - points[1].clientX, points[0].clientY - points[1].clientY);
        gesture.centerX = (points[0].clientX + points[1].clientX) / 2;
        gesture.centerY = (points[0].clientY + points[1].clientY) / 2;
      }
    }
    function move(points, event) {
      if (!gesture) return;
      if (points.length > 1) {
        if (!gesture.pinch) start(points);
        const distance = Math.hypot(points[0].clientX - points[1].clientX, points[0].clientY - points[1].clientY);
        const rect = viewport.getBoundingClientRect();
        state.scale = clamp(gesture.scale * distance / Math.max(gesture.distance, 1), 1, 3);
        const ratio = state.scale / gesture.scale;
        const cx = gesture.centerX - rect.left - rect.width / 2;
        const cy = gesture.centerY - rect.top - rect.height / 2;
        state.x = cx - (cx - gesture.x) * ratio + (points[0].clientX + points[1].clientX) / 2 - gesture.centerX;
        state.y = cy - (cy - gesture.y) * ratio + (points[0].clientY + points[1].clientY) / 2 - gesture.centerY;
        gesture.moved = true;
        if (event.cancelable) event.preventDefault();
        render(); return;
      }
      gesture.dx = points[0].clientX - gesture.startX;
      gesture.dy = points[0].clientY - gesture.startY;
      if (Math.hypot(gesture.dx, gesture.dy) > 8) gesture.moved = true;
      if (state.scale > 1) {
        state.x = gesture.x + gesture.dx; state.y = gesture.y + gesture.dy;
        viewport.dataset.dragging = String(gesture.moved);
        if (event.cancelable) event.preventDefault();
        render();
      } else if (Math.abs(gesture.dx) > 12 && Math.abs(gesture.dx) > Math.abs(gesture.dy) * 1.5 && event.cancelable) {
        event.preventDefault();
      }
    }
    function finish(cancelled) {
      if (!gesture) return;
      if (gesture.moved || gesture.pinch) suppressUntil = Date.now() + 500;
      if (!cancelled && !gesture.pinch && state.scale === 1) {
        const direction = swipe(gesture.dx, gesture.dy);
        if (direction && slides.length > 1) change(direction);
      }
      gesture = null; viewport.dataset.dragging = 'false';
    }
    viewport.addEventListener('touchstart', event => start([...event.touches]), { passive: true });
    viewport.addEventListener('touchmove', event => move([...event.touches], event), { passive: false });
    viewport.addEventListener('touchend', event => {
      if (event.touches.length) { suppressUntil = Date.now() + 500; start([...event.touches]); }
      else finish(false);
    });
    viewport.addEventListener('touchcancel', () => finish(true));
    viewport.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      start([event]);
      if (state.scale > 1) viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', event => { if (event.pointerType !== 'touch') move([event], event); });
    viewport.addEventListener('pointerup', event => { if (event.pointerType !== 'touch') finish(false); });
    viewport.addEventListener('pointercancel', () => finish(true));
    viewport.addEventListener('pointerleave', event => { if (event.pointerType !== 'touch' && state.scale === 1) finish(true); });
    viewport.addEventListener('keydown', event => {
      if (event.target !== viewport) return;
      if (['+', '=', '-', '0', 'Home', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) event.preventDefault();
      if (event.key === '+' || event.key === '=') zoom(.5);
      else if (event.key === '-') zoom(-.5);
      else if (['0', 'Home', 'Escape'].includes(event.key)) reset();
      else if (event.key.startsWith('Arrow')) {
        if (state.scale === 1) {
          if (event.key === 'ArrowLeft') change(-1);
          if (event.key === 'ArrowRight') change(1);
        } else {
          state.x += event.key === 'ArrowLeft' ? 40 : event.key === 'ArrowRight' ? -40 : 0;
          state.y += event.key === 'ArrowUp' ? 40 : event.key === 'ArrowDown' ? -40 : 0;
          render();
        }
      }
    });
    // Instant transforms avoid motion sensitivity and keep hotspots locked to the photo.
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(render); observer.observe(viewport);
      root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
    change(0);
  }
  const init = () => document.querySelectorAll('[data-ride-selector]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
